<h4>Carregados recentemente</h4>
<div >
   
    <figure class="poster" 
    *ngFor="let item of [1,2,3,4,5,6,7,8,9]">
        <img src="../../../assets/img/landpage/evangeline-shaw-xRlI-L-kvrw-unsplash.jpg" alt="">
    
        <figcaption class="section">
           <ul>
               <li>

                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 311 311">
                    <defs>
                      <linearGradient id="linear-gradient" x1="-0.126" y1="0.549" x2="0.753" y2="0.594" gradientUnits="objectBoundingBox">
                        <stop offset="0" stop-color="#5c3aed"/>
                        <stop offset="0.623" stop-color="#6851c9" stop-opacity="0.667"/>
                        <stop offset="0.699" stop-color="#756ba1" stop-opacity="0.302"/>
                        <stop offset="0.707" stop-color="#797296" stop-opacity="0.2"/>
                        <stop offset="0.803" stop-color="#7a7592" stop-opacity="0.161"/>
                        <stop offset="1" stop-color="gray" stop-opacity="0"/>
                      </linearGradient>
                      <pattern id="pattern" preserveAspectRatio="xMidYMid slice" width="100%" height="100%" viewBox="0 0 500 750">
                        <image width="500" height="750" href="../../../assets/svg/user/img1.jpeg"></image></pattern>
                    </defs>
                    <g id="Group_23" data-name="Group 23" transform="translate(-17894.345 810.655)">
                      <circle id="Ellipse_1" data-name="Ellipse 1" cx="155.5" cy="155.5" r="155.5" transform="translate(17894.344 -810.655)" fill="url(#linear-gradient)"/>
                      <g id="photo-1545946551-0b395ce5b5f4" transform="translate(17919.344 -785.655)" stroke="#707070" stroke-width="1" fill="url(#pattern)">
                        <circle cx="131" cy="131" r="131" stroke="none"/>
                        <circle cx="131" cy="131" r="130.5" fill="none"/>
                      </g>
                    </g>
                  </svg>

               </li>
               <li> <h4>Prof: John Doe</h4> <p>Logica combinaciona <strong>History</strong> </p> </li>
               
           </ul>
           <div>
               <p> 
                  <span>Informatica</span> 
                  <span class="bump">2º ano</span> 
              </p>
           </div>
         
        </figcaption>
    </figure>
   
</div>